import { useMemo } from 'react';
/**
 * Хук useMemo, который используется глубокое сравнение
 * @deprecated Использовать useDeepMemo из https://git.moscow.alfaintra.net/projects/NEWCLICK/repos/newclick-helpers/browse/src/hooks/use-deep-memo/index.ts
 */
export const useDeepMemo = (value) => {
    const reult = useMemo(() => value, 
    // Если прокидывать обьект напрямую, ссылка на него меняется при каждом рендере и получем зацикленный вызов, поэтому проверяем на сам обьект
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(value)]);
    return reult;
};
